export default __webpack_public_path__ + "static/banner-mobile-5ae9d6807f0d5224dd774555843ceb54.png";